import { StyledSection } from "libs/styled-components/styles";
import { useCallback, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  PaidContainer,
  ImageContainer,
  ListContainer,
  DescriptionContainer,
  PublicContainer,
  WatchContainer,
} from "./styles";
import { Printer, Share } from "assets/svg";
import GlobalContext from "context";
import Banner from "assets/images/banner-placeholder.png";
import { FormattedMessage, useIntl } from "react-intl";
import { saveLog } from "services/logs";
import { formatDate } from "utils";

const EventSection = ({ event }) => {
  const { user } = useContext(GlobalContext);
  const navigate = useNavigate();
  const onPrintQRCode = () => {
    navigate(`/events/print/${event.id}`);
  };

  const recordLink = useMemo(() => {
    return `https://evento.capsuladotempo.com/?event=${event.code}`;
  }, [event]);

  const onOpenLink = useCallback(() => {
    saveLog({
      action: "open-link",
      event: event?.id,
      user: user?.id,
      data: {
        component: "Events/EventSection",
        recordLink: recordLink,
        eventTitle: event?.title,
        eventDate: event?.date,
        eventCode: event?.code,
        eventStatus: event?.status,
        userEmail: user?.email,
        userName: user?.name,
        userOwner: event?.userOwner,
        userOwnerEmail: event?.userOwnerEmail,
        userOwnerName: event?.userOwnerName,
      },
    });
  }, [event, recordLink, user]);

  const intl = useIntl();

  const onShare = useCallback(() => {
    const text = intl.formatMessage({ id: "message.shareLink" });
    if (navigator.share) {
      navigator
        .share({
          title: event?.title,
          url: recordLink,
          text: text,
        })
        .then(() => {
          console.log("Thanks for sharing!");
          saveLog({
            action: "share-event",
            event: event?.id,
            user: user?.id,
            data: {
              component: "Events/EventSection",
              recordLink: recordLink,
              eventTitle: event?.title,
              eventDate: event?.date,
              eventCode: event?.code,
              eventStatus: event?.status,
              userEmail: user?.email,
              userName: user?.name,
              userOwner: event?.userOwner,
              userOwnerEmail: event?.userOwnerEmail,
              userOwnerName: event?.userOwnerName,
            },
          });
        })
        .catch(console.error);
    } else {
      console.log("no-navigator");
    }
  }, [event, recordLink, intl, user]);

  return (
    <StyledSection>
      <Container>
        <PublicContainer>
          <ImageContainer>
            <img src={event.banner ? event.banner : Banner} alt={event.title} />
          </ImageContainer>
          <DescriptionContainer>
            <label>
              <FormattedMessage id="event.date" />:{" "}
              {formatDate(event.market, event.date)}
            </label>
            {event.releaseDate && (
              <label>
                <FormattedMessage id="label.releaseDate" />:{" "}
                {formatDate(event.market, event.releaseDate)}
              </label>
            )}
            <label>
              <FormattedMessage id="event.code" />:<span>{event.code}</span>
            </label>
            <ListContainer>
              <FormattedMessage id="event.recipients" />:
              <ul>
                <li>
                  <div>
                    <label>{user.name}</label>
                    <span>{user.email}</span>
                  </div>
                </li>
                {event.mailList &&
                  event.mailList.map((mail) => {
                    return (
                      <li key={mail.email}>
                        <div>
                          <label>{mail.name}</label>
                          <span>{mail.email}</span>
                        </div>
                      </li>
                    );
                  })}
              </ul>
            </ListContainer>
          </DescriptionContainer>
        </PublicContainer>
        {(event.status === "scheduled" || event.status === "open") && (
          <WatchContainer>
            <h2>
              <FormattedMessage id="message.videos.scheduled" />
            </h2>
            <button onClick={() => navigate(`../videos/${event.id}`)}>
              <FormattedMessage id="videos.open" />
            </button>
          </WatchContainer>
        )}

        {(event.status === "published" || event.status === "open") && (
          <PaidContainer>
            <h2>
              <FormattedMessage id="message.event.ready" />
            </h2>
            <p>
              <FormattedMessage id="message.event.ready.description" />
            </p>
            <div>
              <a
                href={recordLink}
                onClick={onOpenLink}
                target="_blank"
                rel="noreferrer"
              >
                <FormattedMessage id="event.link" />
                <Share
                  height="26px"
                  width="26px"
                  outline="#f76c6f"
                  color="transparent"
                />
              </a>
              {navigator.share && (
                <button type="button" onClick={onShare}>
                  <FormattedMessage id="button.share" />
                  <Share
                    height="26px"
                    width="26px"
                    outline="#fff"
                    color="transparent"
                  />
                </button>
              )}
              <button onClick={onPrintQRCode}>
                <FormattedMessage id="event.qrCode" />
                <Printer
                  height="26px"
                  width="26px"
                  outline="white"
                  color="transparent"
                />
              </button>
            </div>
          </PaidContainer>
        )}
      </Container>
    </StyledSection>
  );
};

export default EventSection;
